import { render, staticRenderFns } from "./Manage-Bank-Name.vue?vue&type=template&id=36cb2a58"
import script from "./Manage-Bank-Name.vue?vue&type=script&lang=js"
export * from "./Manage-Bank-Name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports